import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

// Kayıtlarda saklanan grup / rol adları Türkçe kalır (profil bu değerlerle
// eşleştirir); ekranda seçili dile göre etiket gösterilir.
const GROUP_KEYS = {
  Hepsi: 'all',
  'Saha Koordinatörü': 'siteCoordinator',
  'Klinik Araştırma Hemşiresi': 'researchNurse',
  'Proje Müdürü': 'projectManager',
  'Çalışma Başlatma Sorumlusu': 'startupLead',
  'Backup Personeli': 'backup',
  CRA: 'cra',
  'Kalite Müdürü': 'qualityManager',
  'Finans Uzmanı': 'finance',
  'IT Uzmanı': 'it',
  'IK Uzmanı': 'hr',
  'İş Geliştirme Uzmanı': 'bizDev',
  'Eğitim Sorumlusu': 'training',
};

/** Texts of the quality screens plus the group-name translator. */
const useQualityText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`quality.${key}`, vars), [t]);
  const groupLabel = useCallback((value) => (GROUP_KEYS[value] ? t(`quality.groups.${GROUP_KEYS[value]}`) : value), [t]);
  return { t, language, locale, label, groupLabel };
};

/** A record's `group` as an array (old records may hold one string). */
export const groupsOf = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

export default useQualityText;
